import React, { createContext } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { NonceProvider } from 'react-select';

import App from './App';
import store from './stores/store';
import { ENV, DEPLOYMENT_TAG, DEPLOYMENT_TIME, STYLE_NONCE } from '@awp/config';

console.log('APP_ENV:', ENV);
console.log('DEPLOYMENT_TAG:', DEPLOYMENT_TAG);
console.log('DEPLOYMENT_TIME:', DEPLOYMENT_TIME);
console.log('STYLE_NONCE:', STYLE_NONCE);

ReactDOM.render(
  <React.StrictMode>
    <NonceProvider nonce={STYLE_NONCE} cacheKey="sawsx">
      <Provider store={store}>
        <App />
      </Provider>
    </NonceProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

if (location.pathname === '/') {
  navigator.serviceWorker.register('service-worker.js');
}
